import styled from "styled-components";

const NavHeaderItem = styled.div`
  @media (max-width: 1023px) {
    display: ${props => (props.hideonmobile ? "none" : "auto")};
  }
`;

export default NavHeaderItem;
